// src/App.js
import React from 'react';
import { BrowserRouter  as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import MainSection from './components/MainSection';
import WeFocusOn from './components/WeFocusOn';
import HowWeDoIt from './components/HowWeDoIt';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import Features from './components/Features';
import Faq from './components/Faq';
import Chatbot from './components/chatbot'; 
import './App.css';


function App() {
  return (
    <Router basename="/EQ_of_AI">
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <div>
            <MainSection />
              <div id="features"> {/* Ensure ID is lowercase */}
                <Features />
              </div>
              <div id="weFocusOn">
                <WeFocusOn />
              </div>
              <div id="howWeDoIt">
                <HowWeDoIt />
              </div>
              <div id="pricing">
                <Pricing />
              </div>
              <div id="testimonials">
                <Testimonials />
              </div>
              <div id="faq">
                <Faq />
              </div>
              <Footer />
              <Chatbot />
            </div>
          } />
          {/* Add more routes here if needed */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
